import React, { Component } from 'react';
import { message, Tree } from 'antd';

import { queryOrgTree } from '@api/core/org';

const { TreeNode } = Tree;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gData: [],
      expandedKeys: [],
    };
  }

  componentDidMount() {
    this.getOrgTree(this.initialValue);
  }

  initialValue = () => {
    const { gData } = this.state;
    gData && gData.length > 0 && this.props.handleChange(gData[0].uuid);
  };

  getOrgTree = callBack => {
    queryOrgTree().then(res => {
      if (res.statusCode === 200) {
        this.setState(
          {
            gData: res.data,
          },
          callBack,
        );
      } else {
        message.error(res.message);
      }
    });
  };

  handleSelect = a => {
    this.props.handleChange(a);
  };

  onExpand = expandedKeys => {
    this.setState({
      expandedKeys,
    });
  };

  renderTreeNodes = data => {
    return data.map(item => {
      if (item.children) {
        return (
          <TreeNode title={this.titleItem(item)} key={item.uuid} dataRef={item}>
            {this.renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return <TreeNode title={this.titleItem(item)} key={item.uuid} dataRef={item} {...item} />;
    });
  };

  titleItem = item => {
    return (
      <span className="treeTitle">
        <span style={{ width: '200px' }}>{item.name}</span>
      </span>
    );
  };

  render() {
    const { gData, expandedKeys } = this.state;
    return (
      <div>
        <Tree
          defaultExpandAll
          onExpand={this.onExpand}
          onSelect={this.handleSelect}
          expandedKeys={expandedKeys}
        >
          {this.renderTreeNodes(gData || [])}
        </Tree>
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/boss/user/ComponentOrg.js